import React, { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from './utils/store'
import { useRehydrateModules } from './components/hooks/useRehydrateModules'
import { protectedRoutes } from './utils/functions/routeConfig'
import ScrollToTop from './components/common/ScrollToTop'
import ProtectedRoute from './components/common/ProtectedRoute'
import ModuleProtectedRoute from './components/common/ModuleProtectedRoute'
import RehydrationGuard from './components/common/RehydrationGuard'
import Loader from './components/common/Loader'

const Login = lazy(() => import('./pages/Login'))
const Layout = lazy(() => import('./components/layout'))
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'))
const LoginOtp = lazy(() => import('./pages/LoginOtp'))
const ChangePassword = lazy(() => import('./pages/ChangePassword'))
const SSORedirectHandler = lazy(() => import('./SSORedirectHandler'))

const App = () => {
  const token = useSelector((state: RootState) => state.auth.token);
  useRehydrateModules();
  return (
    <>
      <ScrollToTop />
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/sso-login" element={<SSORedirectHandler />} />
          <Route path='/login' element={<Login />} />
          <Route path='/forgot-password' element={<ForgotPassword />} />
          <Route path='/otp' element={<LoginOtp />} />
          <Route path='/change-password' element={<ChangePassword />} />
          <Route path="/*" element={
            <ProtectedRoute>
              <RehydrationGuard>
                <Layout />
              </RehydrationGuard>
            </ProtectedRoute>
          }>
            {protectedRoutes.map(({ path, component: Component, moduleName, permission }) => {
              const element = moduleName && permission ? (
                <ModuleProtectedRoute moduleName={moduleName} permission={permission}>
                  <Component />
                </ModuleProtectedRoute>
              ) : (
                <Component />
              );

              return <Route key={path} path={path} element={element} />;
            })}
          </Route>
          <Route
            path="/*"
            element={<Navigate to={!token ? "/login" : '/utilization/health-checks'} replace />}
          />
        </Routes>
      </Suspense>
    </>
  )
}

export default App